/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitPrivacyCookieCompliance } from './MonitPrivacyCookieCompliance';
import {
    MonitPrivacyCookieComplianceFromJSON,
    MonitPrivacyCookieComplianceFromJSONTyped,
    MonitPrivacyCookieComplianceToJSON,
} from './MonitPrivacyCookieCompliance';

/**
 * 
 * @export
 * @interface MonitPrivacyTechnologiesResult
 */
export interface MonitPrivacyTechnologiesResult {
    /**
     * 
     * @type {Array<MonitPrivacyCookieCompliance>}
     * @memberof MonitPrivacyTechnologiesResult
     */
    cookie_compliance: Array<MonitPrivacyCookieCompliance>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitPrivacyTechnologiesResult
     */
    chatbot: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitPrivacyTechnologiesResult
     */
    analytics: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitPrivacyTechnologiesResult
     */
    advertising: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitPrivacyTechnologiesResult
     */
    fingerprinting: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitPrivacyTechnologiesResult
     */
    tag_manager: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitPrivacyTechnologiesResult
     */
    geolocation: Array<string>;
}

/**
 * Check if a given object implements the MonitPrivacyTechnologiesResult interface.
 */
export function instanceOfMonitPrivacyTechnologiesResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "cookie_compliance" in value;
    isInstance = isInstance && "chatbot" in value;
    isInstance = isInstance && "analytics" in value;
    isInstance = isInstance && "advertising" in value;
    isInstance = isInstance && "fingerprinting" in value;
    isInstance = isInstance && "tag_manager" in value;
    isInstance = isInstance && "geolocation" in value;

    return isInstance;
}

export function MonitPrivacyTechnologiesResultFromJSON(json: any): MonitPrivacyTechnologiesResult {
    return MonitPrivacyTechnologiesResultFromJSONTyped(json, false);
}

export function MonitPrivacyTechnologiesResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPrivacyTechnologiesResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cookie_compliance': ((json['cookie_compliance'] as Array<any>).map(MonitPrivacyCookieComplianceFromJSON)),
        'chatbot': json['chatbot'],
        'analytics': json['analytics'],
        'advertising': json['advertising'],
        'fingerprinting': json['fingerprinting'],
        'tag_manager': json['tag_manager'],
        'geolocation': json['geolocation'],
    };
}

export function MonitPrivacyTechnologiesResultToJSON(value?: MonitPrivacyTechnologiesResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cookie_compliance': ((value.cookie_compliance as Array<any>).map(MonitPrivacyCookieComplianceToJSON)),
        'chatbot': value.chatbot,
        'analytics': value.analytics,
        'advertising': value.advertising,
        'fingerprinting': value.fingerprinting,
        'tag_manager': value.tag_manager,
        'geolocation': value.geolocation,
    };
}

